import React, { useState, useMemo, useRef, useEffect } from 'react';
import axios from "axios";
import configData from "../../../config/config.json";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { notifysuccess, notifyfailure, notifycatch } from "../../../utils/toast";
import { useOnboardingStep } from '../../../context/OnboardingStepContext';
import loaderIcon from '../../../assets/images/icons/loader.gif';
import { Row, Col, Button } from 'antd';
import HelixImg from '../../../assets/newlayout/welcome_text_img.svg';
import RightImgOne from '../../../assets/newlayout/right_img_one.svg';


const connectorPaths = [
    'M214 0.30006L214 269.3',
    'M332.012 1140.3L332.012 871.3',
    'M94 449.3L94 365.3',
    'M214 449.3L214 365.3',
    'M334 449.3L334 365.3',
    'M93 781.3L93 697.3',
    'M213 781.3L213 697.3',
    'M333 781.3L333 697.3',
    'M467 651.971L387 651.971',
    'M467 570.971L387 570.971',
    'M467.004 490.471L387.001 489.471',
];

const OnboardingStep2 = (props) => {
    const { setInternalStep } = useOnboardingStep();
    const [buttonValue, setButtonValue] = useState(false);
    const [isIllustrationReady, setIsIllustrationReady] = useState(false);
    const animationFrameRef = useRef(null);
    const animationDelayRef = useRef(null);

    const handleIllustrationLoad = () => {
        // Keep the connector hidden until the base SVG has visibly settled.
        animationDelayRef.current = window.setTimeout(() => {
            animationFrameRef.current = window.requestAnimationFrame(() => {
                setIsIllustrationReady(true);
            });
        }, 400);
    };

    useEffect(() => () => {
        if (animationDelayRef.current) {
            window.clearTimeout(animationDelayRef.current);
        }
        if (animationFrameRef.current) {
            window.cancelAnimationFrame(animationFrameRef.current);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setButtonValue(true);

        const isRegisterFlow = props.callFrom === "register";

        if (!isRegisterFlow && !Cookies.get("token_xapads_ssp")) {
            setButtonValue(false);
            return;
        }

        const token = isRegisterFlow ? null : Cookies.get("token_xapads_ssp");
        const _id = isRegisterFlow ? props.pubId : jwtDecode(token)._id;
        const url = `${configData.SERVER_URL}ops/updateOnboardingStep`;
        const headers = token ? { "x-access-token": token } : {};

        axios
            .put(url, { step: 2, _id }, { headers })
            .then((response) => {
                // notifysuccess(response.data.message);
                if (props.onNext) {
                    setTimeout(() => { props.onNext(); setInternalStep(2); }, 500);
                } else {
                    setTimeout(() => { window.location.reload(); }, 1500);
                }
            })
            .catch((error) => {
                if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                    }
                } else {
                    notifycatch();
                }
                setButtonValue(false);
            });
    };
    const animatedConnectors = useMemo(() => (
        connectorPaths.map((path) => {
            const duration = 1.35 + Math.random() * 0.25;

            return {
                path,
                duration: `${duration.toFixed(2)}s`,
                // Start each path partway through its cycle, avoiding a static wait on entry.
                delay: `-${(Math.random() * duration).toFixed(2)}s`,
            };
        })
    ), []);

    return (
        <div className='welcome_to_helix_div'>
            <Row>
                <Col span={9} className='welcome_to_helix_content'>
                    <div className='welcome_to_helix_heading'>
                        <div className='welcome_to_helix_text'>
                            <img src={HelixImg} className='img-fluid' alt="Helix" />
                            <p>To kick things off, we'd love to learn more about your company to better serve your needs.</p>
                        </div>
                        <div className='btn_group'>
                            {/* <Button className='btn btn_primary w_fit_content md'>Let’s get Started!</Button> */}
                            <Button className='btn btn_primary w_fit_content md' onClick={handleSubmit}>
                                {!buttonValue ? <> Let’s get Started!</> : <>Loading ...</>}

                            </Button>
                        </div>
                    </div>
                </Col>
                <Col span={15} className='welcome_to_helix_content position-relative'>
                    <div className='welcome_to_helix_img'>
                        <img
                            src={RightImgOne}
                            className='img-fluid'
                            alt="Right Image One"
                            onLoad={handleIllustrationLoad}
                        />
                        <svg
                            className={`welcome_to_helix_connector_animation${isIllustrationReady ? ' is-ready' : ''}`}
                            viewBox="0 0 910 1141"
                            aria-hidden="true"
                        >
                            {animatedConnectors.map(({ path, duration, delay }, index) => (
                                <path
                                    key={`${path}-${index}`}
                                    d={path}
                                    pathLength="100"
                                    className="welcome_to_helix_connector_animation__line"
                                    style={{ '--line-duration': duration, '--line-delay': delay }}
                                />
                            ))}
                        </svg>
                    </div>
                </Col>
            </Row>
        </div>
    )

};

export default OnboardingStep2;
